import { Button, Image, Modal, Space, Spin, Table, message } from 'antd';
import './index.less';
import { useEffect, useState } from 'react';
import AppModal from './appModal';
import { ColumnsType } from 'antd/lib/table';
import { getAppListApi, deleteAppApi } from '@/services/signAndPayment';
import { EyeOutlined } from '@ant-design/icons';
import moment from 'moment';

const { confirm } = Modal;

interface DataType {
  appId: string;
  secret: string;
  name: string;
  code: string;
  icon: string;
  iconUrl?: string;
  description: string;
  createdAt: number;
  updatedAt: number;
}

const AppManage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editType, setEditType] = useState(0);
  const [selectedApp, setSelectedApp] = useState({});
  const [appList, setAppList] = useState([]);

  const getAppList = async () => {
    const res = await getAppListApi();
    if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
      setAppList(res.data.details);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAppList();
  }, []);

  const editApp = (type: number, record: any) => {
    setSelectedApp(record);
    setEditType(type);
    setEditVisible(true);
  };

  const handleCancel = () => {
    setEditVisible(false);
    getAppList();
  };

  const deleteApp = (record: any) => {
    confirm({
      title: `确定要删除【${record.name}】应用？`,
      content: '应用是接口调用的重要主体，请谨慎删除，删除后将无法恢复',
      okText: '确定',
      onOk: async () => {
        const res = await deleteAppApi(record.appId);
        if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
          message.info('应用删除成功');
          getAppList();
        }
      },
    });
  };

  const columns: ColumnsType<DataType> = [
    {
      title: '应用名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '应用标识',
      dataIndex: 'code',
      key: 'code',
      width: 150,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '应用Id',
      dataIndex: 'appId',
      key: 'appId',
      width: 250,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '应用Secret',
      dataIndex: 'secret',
      key: 'secret',
      width: 250,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '应用图标',
      dataIndex: 'iconUrl',
      key: 'iconUrl',
      width: 250,
      render: (text) =>
        text && (
          <div className="iconFile" style={{ width: `50px`, height: `50px` }}>
            <Image preview={{ mask: <EyeOutlined /> }} height={50} src={text} />
          </div>
        ),
    },
    {
      title: '应用描述',
      dataIndex: 'description',
      key: 'description',
      width: 250,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      render: (text) => <span>{moment(text * 1000).format('YYYY.MM.DD HH:mm')}</span>,
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {/* <div className="actionBtn" style={{color: record.status ? 'red': ''}} onClick={() => updateSignStatus(record)}>{record.status ? '禁用' : '启用'}</div> */}
          <div className="actionBtn" onClick={() => editApp(1, record)}>
            编辑
          </div>
          <div className="actionBtn" style={{ color: 'red' }} onClick={() => deleteApp(record)}>
            删除
          </div>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="appTitle">应用管理</div>
      <div className="appBody">
        <div className="appHead">
          <Button type="primary" onClick={() => editApp(0, {})}>
            新增
          </Button>
        </div>
        <Spin spinning={loading}>
          <div className="appContent">
            <Table
              columns={columns}
              dataSource={appList}
              rowKey={(record: any) => record.appId}
              pagination={false}
              scroll={{ x: true, y: 'calc(100vh - 340px)' }}
            />
          </div>
        </Spin>
        {editVisible && (
          <AppModal
            data={selectedApp}
            visible={editVisible}
            editType={editType}
            handleCancel={handleCancel}
          />
        )}
      </div>
    </div>
  );
};

export default AppManage;
